import React from 'react';
export var SvgWrapper = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, children = _a.children;
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 " + width + " " + height, version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, children));
};
